export const environment = {
  hasura: {
    url: 'https://graphql.old.dev.join4green.com/v1/graphql',
    wss: 'wss://graphql.old.dev.join4green.com/v1/graphql',
    storage: 'https://storage.dev.join4green.com/v1',
  },
  keycloak: {
    url: 'https://auth.dev.join4green.com',
    realm: 'J4G',
    clientId: 'app',
  },
  overpass: {
    url: 'https://overpass-api.de/api/interpreter',
  },
  // hasura: {
  //   url: 'https://graphql.prod.join4green.com/v1/graphql',
  //   wss: 'wss://graphql.prod.join4green.com/v1/graphql',
  //   storage: 'https://storage.prod.join4green.com/v1',
  // },
  // keycloak: {
  //   url: 'https://auth.prod.join4green.com',
  //   realm: 'J4G',
  //   clientId: 'app',
  // },
  // overpass: {
  //   url: 'https://overpass-api.de/api/interpreter',
  // },
};
